module.exports = __webpack_public_path__ + "img/GAME_MULTI GOSTOP2.3aaa754a.jpg";